import React from "react";
import { Helmet } from "react-helmet";
import { TimeLineBanner } from "../../blocks/timeline-banner";
import { TimelineContent } from "../../blocks/timeline-content";
import { Footer } from "../../components/FooterV2";
import { Header } from "../../components/Header";
import { Link } from "../../components/Link";
import "./styles.less";

export const TimelinePage = () => {
  return (
    <div className="timeline-page">
      <Helmet>
        <title>Authing发展历程-Authing身份云</title>
      </Helmet>
      <Header mode="dark" />
      <TimeLineBanner />
      <TimelineContent />
      <Footer />
    </div>
  );
};
